import { PaymentService } from '../services/PaymentService.js';

export const RUNE_PACKS = [
  { id: 'pack_100',  runes: 100,  priceUsd: 1.00, label: '100 Runes' },
  { id: 'pack_500',  runes: 500,  priceUsd: 4.50, label: '500 Runes' },
  { id: 'pack_1200', runes: 1200, priceUsd: 9.00, label: '1200 Runes' },
] as const;

function getApiBase(): string {
  const envUrl = (import.meta as any).env?.VITE_API_URL;
  if (envUrl) return envUrl;
  if (typeof window !== 'undefined' && window.location?.hostname !== 'localhost') return '';
  return 'http://localhost:4000';
}

export class RunePurchaseOverlay {
  private overlay: HTMLElement | null = null;
  private svc: PaymentService;

  constructor(
    private readonly authToken: string,
    private readonly onSuccess?: (runes: number) => void,
  ) {
    this.svc = new PaymentService(authToken, (window as any).ethereum, getApiBase());
  }

  open(packId: string, packName: string, priceUsd: number): void {
    this.close();

    const container = (document.getElementById('game-container') ?? document.body) as HTMLElement;
    this.overlay = document.createElement('div');
    this.overlay.setAttribute('data-rune-overlay', '');
    this.overlay.style.cssText =
      'position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.85);z-index:10000;';

    this.overlay.innerHTML = `
      <div style="background:#0d0a0e;border:2px solid #5a3600;padding:24px 28px;width:340px;box-sizing:border-box;font-family:Georgia,serif;">
        <div style="color:#c8973a;font-size:14px;font-weight:bold;letter-spacing:1px;text-align:center;margin-bottom:6px;">✦  Buy Runes  ✦</div>
        <div style="color:#8a7040;font-size:11px;text-align:center;margin-bottom:18px;">${packName} · $${priceUsd.toFixed(2)} USD</div>
        <div style="color:#6b4020;font-size:10px;letter-spacing:1px;margin-bottom:10px;text-align:center;">SELECT PAYMENT TOKEN</div>
        <div style="display:flex;gap:8px;justify-content:center;margin-bottom:14px;">
          <button data-token="ETH"  style="background:#0a0a1a;border:1px solid #3a3a6a;color:#9a9aca;font-family:Georgia,serif;font-size:11px;padding:8px 14px;cursor:pointer;min-width:72px;">ETH</button>
          <button data-token="USDC" style="background:#0a1a0a;border:1px solid #2a5a2a;color:#6aaa6a;font-family:Georgia,serif;font-size:11px;padding:8px 14px;cursor:pointer;min-width:72px;">USDC</button>
          <button data-token="USDT" style="background:#1a1a0a;border:1px solid #5a5a2a;color:#aaaa6a;font-family:Georgia,serif;font-size:11px;padding:8px 14px;cursor:pointer;min-width:72px;">USDT</button>
        </div>
        <div data-rune-status style="min-height:20px;text-align:center;font-size:10px;color:#8a7040;margin-bottom:10px;"></div>
        <div style="text-align:center;">
          <button data-rune-cancel style="background:none;border:none;color:#4a3010;font-family:Georgia,serif;font-size:10px;cursor:pointer;">— Cancel —</button>
        </div>
      </div>`;

    container.appendChild(this.overlay);

    const status = this.overlay.querySelector('[data-rune-status]') as HTMLElement;

    this.overlay.querySelectorAll('button[data-token]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const token = (btn as HTMLElement).dataset.token as 'ETH' | 'USDC' | 'USDT';
        this.setButtonsDisabled(true);
        status.style.color = '#8a7040';
        status.textContent = 'Waiting for MetaMask…';

        try {
          const result = await this.svc.purchase(packId, token);
          status.style.color = '#6aaa60';
          status.textContent = `✓ ${result.runes} runes added!`;
          this.onSuccess?.(result.runes);
          setTimeout(() => this.close(), 1500);
        } catch (err: unknown) {
          const msg = err instanceof Error ? err.message : 'Purchase failed';
          status.style.color = '#aa5a5a';
          status.textContent = msg;
          this.setButtonsDisabled(false);
        }
      });
    });

    this.overlay.querySelector('[data-rune-cancel]')!.addEventListener('click', () => this.close());
  }

  close(): void {
    this.overlay?.remove();
    this.overlay = null;
  }

  private setButtonsDisabled(disabled: boolean): void {
    this.overlay?.querySelectorAll('button[data-token]').forEach(btn => {
      (btn as HTMLButtonElement).disabled = disabled;
    });
  }
}
